import Tab from './tab'
import {
  Overall,
  LOBOverview,
  LOBSubmit,
} from './tab-content'

export {
  Tab,
  Overall,
  LOBOverview,
  LOBSubmit,
}



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/index.js